module.exports = __webpack_public_path__ + "img/s-title.c8842791.png";